import { render, staticRenderFns } from "./CargoVehicleDepartureForm.vue?vue&type=template&id=454d8ccb"
import script from "./CargoVehicleDepartureForm.vue?vue&type=script&lang=js"
export * from "./CargoVehicleDepartureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports